<template>

  <vs-row class="select_row"
  vs-align="center"
  vs-type="flex" vs-justify="center" vs-w="12">
  <!-- {{bool}} -->
    <p v-if="bool == null" class="select_count">Select</p>
    <select v-model="bool"
    @change="update(params)"
      class="w-100 selectExample mt-2 customSelect 111">
      <option :key="index"
       :value="item.optionsvaluename" 
       :label="item.optionsvaluename"
        v-for="(item,index) 
        in params.colDef.CellRendererParams.custom_fields[0].multivalue"
       class="selectOptionclass"/>
    </select>
  </vs-row>
</template>
<script>
import vSelect from 'vue-select'
import { LeadMixin } from './mixins/LeadMixin'
export default {
  components:{
    vSelect
  },
    mixins: [LeadMixin],
  data () {
    return {
      bool: null,
      
      addDetailsModal:false,
      leadFullDetails:'',
      leadform:{},
      lead_id:[],
    }
  },
  /*  created () {
  }, */
  mounted () {
    this.bool= this.params.data[this.params.colDef.CellRendererParams.item_name]
  
    console.log(this.params)
    
  },

  methods: {
      async update(data1){
          const data = []
          data.leads_id = this.params.data.leads_id
          data.colId = this.params.column.colId
          data.fieldvalue = this.bool
          const index = this.params.rowIndex
          const oldValue = this.params.oldValue

          this.update_lead(data, index)
      },
  }
}
</script>
<style scoped>
  .customSelect {
    border-radius:3px;
    border: 1px solid #CCCCCC;
    width: 100%;
    height:30px;
    background-color: white;
    color:#757575
    /* font-family: $font-family-base'; */
  }
  .selectOptionclass :hover
  {
    background-color:yellow;
    color:white;
    border:none;
  }

</style>
